import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, EchangeState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type EchangeGetter = GetterTree<EchangeState, RootState>

const state: EchangeState = {
  count: null,
  echanges: null,
  echange: null,
  paginationParams: null,
  sortParams: null,
  limitParam: 20,
  filterParams: null
}

export const getters: EchangeGetter = {
  echangesCountGetter: (state) => state.count,
  echangesGetter: (state) => state.echanges,
  echangeGetter: (state) => state.echange,
  echangeSortParamsGetter: (state) => state.sortParams,
  echangeFilterParamsGetter: (state) => state.filterParams,
  echangeLimitParamGetter: (state) => state.limitParam,
  echangePaginationParamsGetter: (state) => state.paginationParams
}

export const actions: ActionTree<EchangeState, RootState> = {
  async getEchangesCountAction({commit}) {
    const {data} = await axios.get(`${apiUrl}/echange/count`)
    commit('getEchangesCountMutation', data)
    return data
  },
  async getEchangesAction({commit, state}, queryParams) {
    const {data} = await axios.get(`${apiUrl}/echange`, {
      params: {
        ...queryParams,
        limit: state.limitParam
      }
    })
    commit('saveEchangePaginationParamsMutation', data)
    commit('getEchangesMutation', data)
    return data
  },
  async getEchangeByIdAction({commit}, id) {
    commit('resetEchangeMutation')
    const {data} = await axios.get(`${apiUrl}/echange/${id}`)
    commit('getEchangeByIdMutation', data)
    return data
  },
  async saveEchangeSortParamsAction({commit}, data) {
    commit('saveEchangeSortParamsMutation', data)
  },
  async saveEchangeFilterParamsAction({commit}, data) {
    commit('saveEchangeFilterParamsMutation', data)
  },
  async saveEchangeLimitParamAction({commit}, data) {
    commit('saveEchangeLimitParamMutation', data)
  },
  async createEchangeAction({commit}, formParams) {
    const {data} = await axios.post(`${apiUrl}/echange`, formParams)
    return data
  },
  async updateEchangeAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/echange/${id}`, formParams)
    return data
  },
  async deleteEchangeAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/echange/${id}`)
    return id
  }
}

const mutations: MutationTree<EchangeState> = {
  getEchangesCountMutation(state, data) {
    state.count = data.count
  },
  getEchangesMutation(state, data) {
    state.echanges = data.data
  },
  getEchangeByIdMutation(state, data) {
    state.echange = data
  },
  saveEchangeSortParamsMutation(state, data) {
    state.sortParams = data
  },
  saveEchangeFilterParamsMutation(state, data) {
    state.filterParams = data
  },
  saveEchangeLimitParamMutation(state, data) {
    state.limitParam = data
  },
  saveEchangePaginationParamsMutation(state, data) {
    state.paginationParams = data
  },
  resetEchangeMutation(state) {
    state.echange = null
  }
}

export const echange: Module<EchangeState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
